import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Spotify(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.55 2 12 2zm4.602 14.45c-.2.3-.55.398-.852.199-2.351-1.45-5.3-1.75-8.8-.95-.353.102-.649-.148-.75-.449-.102-.352.147-.649.449-.75 3.8-.852 7.102-.5 9.7 1.101.351.149.402.547.253.848zM17.8 13.7c-.25.351-.7.5-1.051.25-2.7-1.649-6.8-2.15-9.95-1.149-.398.102-.85-.102-.949-.5-.101-.398.101-.852.5-.95 3.649-1.1 8.148-.55 11.25 1.353.297.148.45.648.2.996zm.098-2.801C14.699 9 9.349 8.797 6.297 9.75c-.5.149-1-.149-1.149-.602-.148-.5.148-1 .602-1.149 3.55-1.05 9.399-.851 13.101 1.352.45.25.602.851.352 1.3-.254.348-.852.497-1.304.247z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Spotify);
export default ForwardRef;